// engine
import { ArContainer, ArSprite, ArLayout, gsap, ORIENTATION } from '@aceroll/core';

// game-objects
import { GameLogo } from '../game-objects/game-logo';
import { LoadingBar } from '../game-objects/loading-bar';
import { PlatformLogo } from '../game-objects/platform-logo';
import { StudioLogo } from '../game-objects/studio-logo';

export default class Loading extends ArLayout {
	init() {
		super.init();

		this.bgContainer = new ArContainer('bgContainer');
		this.bgContainer.baseSize = {
			[ORIENTATION.LANDSCAPE]: {
				width: 2048,
				height: 2048
			},
			[ORIENTATION.PORTRAIT]: {
				width: 2048,
				height: 2048
			}
		};
		this.bgContainer.scaleMode = 'max';
		this.background = ArSprite.from('img-background-loading');
		this.background.anchor.set(0.5, 0.5);
		this.background.position.set(1024, 1024);
		this.bgContainer.addChild(this.background);

		this.gameContainer = new ArContainer('gameContainer');

		this.loadingBar = new LoadingBar();
		this.gameLogo = new GameLogo();
		this.platformLogo = new PlatformLogo();
		this.studioLogo = new StudioLogo();

		this.gameContainer.addChild(
			this.studioLogo,
			this.gameLogo,
			this.loadingBar,
			this.platformLogo,
		);
		this.root.addChild(
			this.bgContainer,
			this.gameContainer
		);
		this.root.alpha = 0;
		this.showTween = gsap.to(this.root, { alpha: 1, duration: 0.8 });
	}

	onLandscape() {
		this.loadingBar.position.set(1171, 890);

		this.studioLogo.position.set(1170, 180);
		this.studioLogo.scale.set(0.8);

		this.platformLogo.position.set(1171, 1060);
		this.platformLogo.scale.set(0.9);

		this.gameLogo.position.set(1170, 524);
	}

	onPortrait() {
		this.loadingBar.position.set(540, 1290);

		this.gameLogo.position.set(540, 880);
		this.studioLogo.position.set(540, 495);
		this.studioLogo.scale.set(1.2);

		this.platformLogo.position.set(540, 2048);
		this.platformLogo.scale.set(1.2);
	}

	destroy() {
		this.root.destroy({ children: true });
		this.showTween.kill();
		this.root.alpha = 1;
	}
}
